export default __webpack_public_path__ + "static/media/heating.b7a13370.png";